import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { packageFormDefault } from "@factory/form/form.default";
import { PackageFormRule, PackageFormSchema } from "@factory/form/form.rule";
import { useQyCreatePackage } from "@factory/query/package.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewPackage() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreatePackage } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Package is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addPackage, isLoading: isCreating } =
    useQyCreatePackage(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<PackageFormSchema>({
    defaultValues: packageFormDefault,
    resolver: zodResolver(PackageFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: PackageFormSchema) => {
    const formData = mapCreatePackage(form);
    addPackage(formData);
  };
  const handleValidateError = (err: FieldErrors<PackageFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
